/* eslint-disable no-restricted-imports */
import { alertsPaths } from '@sternum/web/features/alerts/routes/paths';
import { attacksPaths } from '@sternum/web/features/attacks/routes/paths';
import { auditLogPaths } from '@sternum/web/features/auditLog/routes/paths';
import { authPaths } from '@sternum/web/features/auth/routes/paths';
import { clientPaths } from '@sternum/web/features/client/routes/paths';
import { dashboardPaths, executiveSummaryPaths } from '@sternum/web/features/dashboard/routes/paths';
import { devicePaths } from '@sternum/web/features/device/routes/paths';
import { fleetsViewPaths } from '@sternum/web/features/fleetsView/routes/paths';
import { integrationsPaths } from '@sternum/web/features/integrations/routes/paths';
import { logsPaths } from '@sternum/web/features/logs/routes/paths';
import { productPaths } from '@sternum/web/features/product/routes/paths';
import { userPaths } from '@sternum/web/features/user/routes/paths';
import { widgetPaths } from '@sternum/web/features/widget/routes/paths';
import { workloadsAlertsPaths, workloadsPaths } from '@sternum/web/features/workloads/routes/paths';

export const routes = {
  auditLog: auditLogPaths,
  auth: authPaths,
  alerts: alertsPaths,
  attacks: attacksPaths,
  user: userPaths,
  clients: clientPaths,
  fleetsView: fleetsViewPaths,
  integrations: integrationsPaths,
  dashboard: dashboardPaths,
  executiveSummary: executiveSummaryPaths,
  logs: logsPaths,
  widget: widgetPaths,
  product: productPaths,
  workloads: workloadsPaths,
  workloadsAlerts: workloadsAlertsPaths,
  device: devicePaths,
} as const;
